import client from "api/client";

// GET /users — paginated. Returns a normalized { items, total, hasMore }.
export const listUsers = async ({ limit = 10, offset = 0 } = {}) => {
  const { data } = await client.get("/users", {
    params: { limit, offset, sort_by: "created_at", sort_desc: true },
  });
  return { items: data.items ?? [], total: data.total ?? 0, hasMore: !!data.has_more };
};

export const createUser = async ({ email, password, role }) => {
  const { data } = await client.post("/users", { email, password, role });
  return data;
};

export const updateUser = async (id, updates) => {
  const { data } = await client.put(`/users/${id}`, updates);
  return data;
};

export const deleteUser = async (id) => {
  await client.delete(`/users/${id}`);
};

export const activateUser = async (id) => {
  await client.post(`/users/${id}/activate`);
};

export const deactivateUser = async (id) => {
  await client.post(`/users/${id}/deactivate`);
};
